import React, { useState } from "react";
import "./style.scss";
import { Row, Col, Button } from "react-bootstrap";
import OnboardHeading from "../../../components/OnboardHeading";
import HeaderForm from "../../../components/HeaderForm";
import { getRevertUser } from "../../../api";
import Loader from "../../../components/Loader";
import revertIcon from "../../../assets/images/fa_refresh.svg";
import { useLocation } from "react-router-dom";
import PdfViewer from "../../../components/CustomPdf/pdf";

const EmployeeCustomPdf = () => {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const { state } = useLocation();
  const pdfFullData = state?.document;
  const pdfData = state?.document?.custom_documents;
  const companyName = localStorage.getItem("company_name");
  const personalInfo = state?.onboardObject?.personal_info;
  const onboardingTasks = state?.onboardObject?.onboarding_tasks;

  const handleRevertUser = () => {
    window.open(getRevertUser(), "_self");
  };

  return (
    <>
      <HeaderForm />
      <div className="boarding-layout board-main-section">
        <Row>
          <Col md={getRevertUser() ? 10 : 12} sm={getRevertUser() ? 8 : 12}>
            <OnboardHeading title="employee" subtitle={companyName} />
          </Col>
          {getRevertUser() ? (
            <Col
              md={2}
              sm={getRevertUser() ? 4 : 2}
              className="d-flex align-items-center justify-content-end mb-4 mb-md-0"
            >
              <div className="revert">
                <Button
                  variant="danger"
                  className="revert_btn"
                  onClick={handleRevertUser}
                >
                  <img
                    src={revertIcon}
                    alt="revert"
                    className="revert-img me-1"
                  />
                  Revert User
                </Button>
              </div>
            </Col>
          ) : (
            ""
          )}
        </Row>
        {!loading && pdfData?.document_url ? (
          <div className="create-board">
            <div className="board-container">
              <div className="pdf-settings">
                <PdfViewer
                  file={pdfData.document_url}
                  pdfData={pdfData}
                  pdfFullData={pdfFullData}
                  personalInfo={personalInfo}
                  onboardingTasks={onboardingTasks}
                  pageType="employee-onboard"
                />
              </div>
            </div>
          </div>
        ) : (
          !loading && (
            <div className="text-danger text-center">
              No PDF available for this document.
            </div>
          )
        )}
        {loading && <Loader />}
      </div>
    </>
  );
};

export default EmployeeCustomPdf;
